/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteNoveltyPricesResponse
 */
export interface DeleteNoveltyPricesResponse {
    /**
     * 
     * @type {number}
     * @memberof DeleteNoveltyPricesResponse
     */
    deletedCount?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteNoveltyPricesResponse
     */
    errors?: Array<string> | null;
}

/**
 * Check if a given object implements the DeleteNoveltyPricesResponse interface.
 */
export function instanceOfDeleteNoveltyPricesResponse(value: object): value is DeleteNoveltyPricesResponse {
    return true;
}

export function DeleteNoveltyPricesResponseFromJSON(json: any): DeleteNoveltyPricesResponse {
    return DeleteNoveltyPricesResponseFromJSONTyped(json, false);
}

export function DeleteNoveltyPricesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteNoveltyPricesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'deletedCount': json['deletedCount'] == null ? undefined : json['deletedCount'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function DeleteNoveltyPricesResponseToJSON(json: any): DeleteNoveltyPricesResponse {
    return DeleteNoveltyPricesResponseToJSONTyped(json, false);
}

export function DeleteNoveltyPricesResponseToJSONTyped(value?: DeleteNoveltyPricesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deletedCount': value['deletedCount'],
        'errors': value['errors'],
    };
}

